module.exports = __webpack_public_path__ + "img/中国乒乓球协会@2x.4fb9459f.png";